import { LoadingOutlined } from '@ant-design/icons';
import { AccessMethod, DeliveryTaskDoc } from '@gooduncles/gu-app-schema';
import { Button } from 'antd';
import { FC } from 'react';

import useStoreCheckListData from 'src/hooks/swr/useStoreCheckListData';

import AccessMethodGroup from 'src/atomic-components/atoms/AccessMethodGroup/AccessMethodGroup';
import StoreDeliveryMemoItem from 'src/atomic-components/atoms/StoreDeliveryNoteItem/StoreDeliveryNoteItem';

import classes from './DailyCheckListForPartner.module.scss';

interface DailyCheckListForPartnerProps {
  partnerName: string;
  deliveryTaskList: DeliveryTaskDoc[];
}

/**
 * 파트너별 일일 체크리스트를 표현합니다.
 */
const DailyCheckListForPartner: FC<DailyCheckListForPartnerProps> = ({ partnerName, deliveryTaskList }) => {
  const { deliveryMemoList, accessInfoListLength, groupedAccessInfoList, isLoading, error, refetchFailedQueries } =
    useStoreCheckListData(deliveryTaskList.map((task) => task.locationId));
  return (
    <div className={classes.checkListContainer}>
      <p className={classes.partnerName}>{partnerName}</p>
      <div className={classes.scrollList}>
        {/* Loading State */}
        {isLoading && <LoadingOutlined />}

        {/* Error State */}
        {error && (
          <div className={classes.errorBox}>
            <p>데이터를 가져오지 못했습니다. 네트워크 확인 후 다시 시도해주세요.</p>
            <Button onClick={refetchFailedQueries}>재시도</Button>
          </div>
        )}

        {/* Check List */}
        {!isLoading && !error ? (
          <>
            {/* Required Keys */}
            <section className={classes.section}>
              <p className={classes.sectionTitle}>필수 지참</p>
              {accessInfoListLength > 0 ? (
                Object.entries(groupedAccessInfoList).map(([method, stores]) => (
                  <AccessMethodGroup
                    key={method}
                    method={method as AccessMethod}
                    stores={stores.map((s) => s.storeName)}
                  />
                ))
              ) : (
                <p className={classes.empty}>확인할 내용이 없습니다.</p>
              )}
            </section>

            <div className={classes.divider} />

            {/* DeliveryMemo */}
            <section className={classes.section}>
              <p className={classes.sectionTitle}>배송 특이사항</p>
              {deliveryMemoList.length > 0 ? (
                deliveryMemoList.map((store, idx) => (
                  <StoreDeliveryMemoItem key={idx} storeNickname={store.storeName} deliveryNote={store.deliveryMemo} />
                ))
              ) : (
                <p className={classes.empty}>확인할 내용이 없습니다.</p>
              )}
            </section>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default DailyCheckListForPartner;
